import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface DescriptionCode {
    _id: string;
    accountNumber: string;
    serviceDescription: string;
    serviceCode: string;
    unitMeasure: string;
    rateHistory: boolean;
    rateHistoryValue: Array<object>;
    unitRate: string;
    useService: string;
    revenueCode: string;
    rateCode: string;
    rateValue: string;
    locatorCode: string;
    useLocator: string;
    claimType: string;
    procedureModifier: string;
    primaryDiagnosis: string;
    diagnosisPointer: string;
    electronicUnit: string;
    procedureQualifier: string;
    addService: string;
    validationTotalBillable: string;
    unitOfMeasure: string;
    roundingAlgorithem: string;
    allowedIncreament: string
}

export const GetDescriptionCode = createAsyncThunk(
    'des/get/',
    async ({ page, pageSize, sortBy, sortDir, searchTerm }: { page?: number, pageSize?: number, sortBy?: string, sortDir?: string, searchTerm?: string  }) => {
        try {
            if (page && pageSize) {
                const response = await axios.get(`des/get?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchTerm=${searchTerm}`)
                return {
                    data: response.data
                }
            } else {
                const response = await axios.get(`des/get`)
                return {
                    data: response.data
                }
            }

        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const getOneDescriptionCode = createAsyncThunk(
    'des/getOne/',
    async (descId: string | undefined) => {
        try {
            const response = await axios.get('des/getOne/' + descId)
            return {
                data: response.data
            }
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const addDescriptionCode = createAsyncThunk(
    'des/create',
    async (data: DescriptionCode) => {
        try {
            const response = await axios.post('des/create', data)
            return response.data
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const deleteDescriptionCode = createAsyncThunk(
    'des/delete/',
    async (data: string) => {
        try {
            const response = await axios.delete('des/delete/' + data)
            return response.data
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const updateDescriptionCode = createAsyncThunk(
    'des/update',
    async (data: DescriptionCode) => {
        try {
            const response = await axios.put('des/update', data)
            return response.data
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)